import { Box, Grid, Paper, Typography, useTheme } from "@material-ui/core";
import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";
import Lines from "./DonutGraph/Lines";

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

export default function DonutGraph({ data: d, choosestep2 }) {
  const id = 100;
  
  // Provide default data structure if d is undefined
  const defaultData = {
    in_progress: 0,
    in_favour_of_claimant: 0,
    in_favour_of_market_participant: 0,
    settlement_awards: 0,
    total: 0,
  };
  
  const safeData = d || defaultData;
  const [data, setdata] = useState(safeData);

  const [series, setSeries] = useState([
    safeData?.in_progress || 0,
    safeData?.in_favour_of_claimant || 0,
    safeData?.in_favour_of_market_participant || 0,
    safeData?.settlement_awards || 0,
  ]);

  const theme = useTheme();
  const chartData = {
    series: series,
    options: {
      chart: {
        id: id,
        // width: 900,
        type: "donut",
        // animations: {
        //   enabled: false,
        // },
      },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            labels: {
              show: true,
              name: {
                show: false,
              },
              value: {
                show: true,
                fontSize: "40px",
                // fontFamily: "Roboto,Helvetica, Arial, sans-serif",
                color: "#333333",
                // formatter: () => "" + data,
              },
              total: {
                show: true,
                label: "Total",
                fontSize: "40px",
                // fontFamily: "Roboto,Helvetica, Arial, sans-serif",
                color: "#333333",
                formatter: () => "" + (safeData?.total || (safeData?.in_progress + safeData?.in_favour_of_claimant + safeData?.in_favour_of_market_participant + safeData?.settlement_awards || 0)),
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      colors: ["#03697D", "#05929C", "#28C2C6", "#6ADACA"],
      labels: ["In Progress", "Arbitration in favor of Applicant/Complainant", "Arbitration in favor of Market Participant", "Settlement Awards"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
          },
        },
      ],
    },
  };

  React.useEffect(() => {
    if (d != data) {
      setdata(d || defaultData);
      setSeries([
        d?.in_progress || 0,
        d?.in_favour_of_claimant || 0,
        d?.in_favour_of_market_participant || 0,
        d?.settlement_awards || 0,
      ]);

      let newoptions = {
        chart: {
          id: id,
          // width: 900,
          type: "donut",
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                name: {
                  show: false,
                },
                // value: {
                //   show: true,
                //   label: "",
                //   fontSize: "30px",
                //   fontFamily: "Roboto,Helvetica, Arial, sans-serif",
                //   color: "#333333",
                //   formatter: () => "" + d,
                // },
                total: {
                  show: true,
                  label: "",
                  fontSize: "30px",
                  fontFamily: "Roboto,Helvetica, Arial, sans-serif",
                  color: "#333333",
                  formatter: () => "" + ((d?.total || 0) || (((d?.in_progress || 0) + (d?.in_favour_of_claimant || 0) + (d?.in_favour_of_market_participant || 0) + (d?.settlement_awards || 0)) || 0)),
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: ["#03697D", "#05929C", "#28C2C6", "#6ADACA"],
        labels: ["In Progress", "Arbitration in favor of Applicant/Complainant", "Arbitration in favor of Market Participant", "Settlement Awards"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
            },
          },
        ],
      };
      ApexCharts.exec(id, "updateOptions", newoptions);
    }
  }, [d, data, series]);

  return (
    <Paper
      style={{
        overflow: "hidden",
        textAlign: "center",
        padding: "3rem",
        height: "-webkit-fill-available",
        maxHeight: "100%",
      }}
    >
      <Box style={{ textAlign: "left" }}>
        <Typography style={{ fontSize: "20px", color: "#333333" }}>
          {"Arbitrations"}
        </Typography>
      </Box>
      <Grid container justify="center">
        <Grid item md={12} sm={12}>
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="donut"
          />
        </Grid>
      </Grid>
      <Box height="3rem" />
      <Lines
        labels={chartData.options.labels}
        cols={chartData.options.colors}
        data={series}
      />
    </Paper>
  );
}
